import { useEffect, useState } from "react";
import { useRef } from "react";
import { QuestionCard, Header, Footer } from "./index";
import "./TestScreen.css";
import SectionTabs from "./SectionTabs";
import useAppHooks from "../../../../shared/hooks/useAppHooks";

import {
  saveAnswerRequest,
  submitExamRequest,
  updateQuestionStatus,
  fetchExamQuestionsListRequest,
  setPaperId,
  setActiveSection,
  fetchExamQuestionRequest,
  setCurrentQuestionIndex,
  resetPracticeStreak,
  hidePracticeProgressiveMessage,
} from "../../../../redux/exam/examSlice";
import { useLocation } from "react-router-dom";
import SubmitModal from "../../../../shared/components/SubmitModal/SubmitModal";
import Modal from "../../../../shared/components/Modal/Modal";
import images from "../../../../utilities/images/images";
import { getQuestionStats } from "../utils/questionStats";
import { ClipLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { getBackendQuestionStatus } from "../../../../shared/utilities/helpers/examQuestionStatus";
import { getExamSectionKey } from "../../../../shared/utilities/helpers/examSectionKey";
import PracticeModeProgressBar from "./PracticeModeProgressBar/PracticeModeProgressBar";

//  NEW PRACTICE MODE PROGRESS BAR
// import PracticeModeProgressBar from "../../../../containers/logged_user_components/user_exercise_test/practice_mode_progress_bar/PracticeModeProgressBar";

const TestScreen = () => {
  const { dispatch, history } = useAppHooks();
const location = useLocation();
  const {
    questionsData,
    currentQuestionIndex,
    loading,
    testDetails,
    plannerDetails,
    paperId,
    selectedSetId,
    timeLeft,
    paper_duration,
    practiceStreak,
  } = useSelector((state) => state.examSlice);

  const stats = getQuestionStats(questionsData);

  // const [activeQuestionId, setActiveQuestionId] = useState(null);
  const [isSubmitModalOpen, setSubmitModalOpen] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [showTimeUpModal, setShowTimeUpModal] = useState(false);
  const autoSubmitTimeoutRef = useRef(null);
  const hasAutoSubmittedRef = useRef(false);

  const isPracticeMode = testDetails?.practiceMode === "practice";
  const allQuestionsAttempted =
    Array.isArray(questionsData) &&
    questionsData.length > 0 &&
    questionsData.every((q) => {
      const selected = q?.selectedOption;
      const hasSelectedOption = Array.isArray(selected)
        ? selected.length > 0
        : selected !== null &&
          selected !== undefined &&
          !(typeof selected === "string" && selected === "");

      const hasIntegerAnswer =
        q?.integerAnswer !== null &&
        q?.integerAnswer !== undefined &&
        String(q?.integerAnswer ?? "").trim() !== "";

      return hasSelectedOption || hasIntegerAnswer;
    });
  // const resumeTestKey =
  //   testDetails?.testId || testDetails?.setId || testDetails?.paperId || null;
  const resumeTestKey =
  testDetails?.setId || testDetails?.testId || testDetails?.paperId;
  // ✅ reset sync flag when new test/resume key changes
useEffect(() => {
  hasSyncedAllRef.current = false;
}, [resumeTestKey]);

  // Ensure streak/progressive message state doesn't leak from a previous attempt.
  useEffect(() => {
    if (isPracticeMode && testDetails?.gamificationOn === true) {
      dispatch(resetPracticeStreak());
      dispatch(hidePracticeProgressiveMessage());
    }
  }, [dispatch, isPracticeMode, testDetails?.gamificationOn, resumeTestKey]);

  /* ======================= LOAD QUESTION LIST ======================= */
  // useEffect(() => {
  //   if (!paperId && testDetails?.paperId) {
  //     dispatch(setPaperId(testDetails?.paperId));
  //   }

  //   if (testDetails?.paperId) {
  //     dispatch(setCurrentQuestionIndex(0));

  //     dispatch(
  //       fetchExamQuestionsListRequest({
  //         paperId: testDetails.paperId,
  //         paperType: plannerDetails?.id,
  //         testId: testDetails?.testId,
  //         setId: selectedSetId,
  //       })
  //     );
  //   }
  // }, [dispatch, testDetails?.paperId]);
useEffect(() => {
  const navState = location.state || {};

  const finalPaperId =
    testDetails?.paperId ?? navState?.paperId ?? null;

  const finalSetId =
    testDetails?.setId ?? navState?.setId ?? null;

  const finalTestId =
    testDetails?.testId ?? navState?.testId ?? null;

  const finalPaperType =
    testDetails?.paperType ?? navState?.paperType ?? plannerDetails?.id;

  if (!finalPaperId && !finalSetId) return;

  // dispatch(setCurrentQuestionIndex(0));

  if (testDetails?.forceFreshStart) {
  dispatch(setCurrentQuestionIndex(0));
}

if (testDetails?.forceFreshStart) {
  localStorage.setItem(`exam_timeSpent_${finalSetId || finalTestId || finalPaperId}`, "0");
}

  dispatch(
    fetchExamQuestionsListRequest({
      paperId: finalPaperId,
      paperType: finalPaperType,
      testId: finalTestId,
      setId: finalSetId,
      practiceMode: testDetails?.practiceMode,
      gamificationOn: testDetails?.gamificationOn,
      isResume: testDetails?.isResume === true,
      forceFreshStart: testDetails?.forceFreshStart === true,
    })
  );

  // ✅ run only when test identity changes
}, [
  dispatch,
  testDetails?.paperId,
  testDetails?.setId,
  testDetails?.testId,
  plannerDetails?.id,
]);

  useEffect(() => {
    if (!resumeTestKey || !questionsData?.length) return;

    const snapshot = {
      testKey: resumeTestKey,
      snapshotVersion: 2,
      currentQuestionQid: questionsData[currentQuestionIndex]?.qid ?? null,
      questions: questionsData.map((q) => ({
        qid: q.qid,
        status: q.status,
        question_status: getBackendQuestionStatus(q),
        selectedOption: q.selectedOption ?? null,
        integerAnswer: q.integerAnswer ?? q.integer_Answer ?? "",
        marked: q.marked === true,
      })),
    };

    localStorage.setItem(
      `exam_resume_state_${resumeTestKey}`,
      JSON.stringify(snapshot)
    );
  }, [resumeTestKey, questionsData, currentQuestionIndex]);


  // Track total time for analytics (practice mode)
useEffect(() => {
  if (!resumeTestKey) return;

  const interval = setInterval(() => {
    const prevTime = Number(
      localStorage.getItem(`exam_timeSpent_${resumeTestKey}`) || 0
    );

    localStorage.setItem(
      `exam_timeSpent_${resumeTestKey}`,
      prevTime + 1
    );
  }, 1000);

  return () => clearInterval(interval);
}, [resumeTestKey]);
  /* ======================= ACTIVE QUESTION ======================= */
  // useEffect(() => {
  //   if (
  //     questionsData &&
  //     questionsData[currentQuestionIndex] &&
  //     questionsData[currentQuestionIndex].qid
  //   ) {
  //     setActiveQuestionId(questionsData[currentQuestionIndex].qid);
  //   }
  // }, [questionsData, currentQuestionIndex]);

//   useEffect(() => {
//   if (
//     questionsData?.length &&
//     questionsData[currentQuestionIndex]?.qid
//   ) {
//     setActiveQuestionId(
//       questionsData[currentQuestionIndex].qid
//     );
//   }
// }, [questionsData, currentQuestionIndex]);

  /* ======================= SAVE & NEXT ======================= */
  const handleSaveAndNext = (e) => {
    e.preventDefault();

    const currentQuestion = questionsData[currentQuestionIndex];
    if (!currentQuestion) return;
const answerType = Number(currentQuestion.answer_type_id);

    dispatch(
      saveAnswerRequest({
        qid: currentQuestion.qid,
        paper_id: currentQuestion.paper_id,
        paper_type: testDetails?.paperType,
        test_id: testDetails?.testId,
        set_id: selectedSetId,
        time: currentQuestion?.time_taken ?? 0,
         option_id:
      answerType === 1 || answerType === 2
        ? currentQuestion?.selectedOption ?? ""
        : "",

    option_int:
      answerType === 3
        ? currentQuestion?.integerAnswer ?? currentQuestion?.integer_Answer ?? ""
        : "",
        question_status: getBackendQuestionStatus(currentQuestion),
      })
    );

    if (currentQuestionIndex < questionsData.length - 1) {
      const nextIndex = currentQuestionIndex + 1;
      const nextQuestion = questionsData[nextIndex];

      const nextSection = getExamSectionKey(nextQuestion);

      const currSection = getExamSectionKey(currentQuestion);

      if (nextSection !== currSection) {
        dispatch(setActiveSection(nextSection));
      }

      dispatch(
        fetchExamQuestionRequest({
          qid: nextQuestion.qid,
          paperId: nextQuestion.paper_id,
          testId: testDetails?.testId,
          setId: selectedSetId,
        })
      );
    }
  };

  const handleSelectQuestion = (qid) => {
    // setActiveQuestionId(qid);

    dispatch(
      updateQuestionStatus({
        qid,
        makeCurrent: true,
        testId: testDetails?.testId,
        setId: selectedSetId,
      })
    );

    const selectedQuestion = questionsData.find((q) => q.qid === qid);
    if (!selectedQuestion) return;

    dispatch(
      fetchExamQuestionRequest({
        qid,
        paperId: selectedQuestion.paper_id,
        testId: testDetails?.testId,
        setId: selectedSetId,
      })
    );
  };

  const onMarkReview = () => {
    const currentQuestion = questionsData[currentQuestionIndex];
    if (!currentQuestion) return;

    dispatch(
      updateQuestionStatus({
        qid: currentQuestion.qid,
        markReview: true,
        testId: testDetails?.testId,
        setId: selectedSetId,
      })
    );
  };

  /* ======================= SUBMIT TEST ======================= */
const handleSubmitExam = () => {
  if (hasAutoSubmittedRef.current && showTimeUpModal) return;

  if (autoSubmitTimeoutRef.current) {
    clearTimeout(autoSubmitTimeoutRef.current);
    autoSubmitTimeoutRef.current = null;
  }

  const finalTime = timeLeft; // ✅ EXACT UI TIMER

  // 🔥 ADD HERE (VERY IMPORTANT - BEFORE DISPATCH)
  const resumeTestKey =
    testDetails?.setId || testDetails?.testId || testDetails?.paperId;

  localStorage.setItem(
    `exam_finalTime_${resumeTestKey}`,
    finalTime
  );

  console.log("FINAL TIMER:", finalTime);

  dispatch(
    submitExamRequest({
      paperType: testDetails?.paperType,
      paperId,
      plannerId: plannerDetails?.planner_id,
      setId: selectedSetId,
      time: finalTime, // ✅ SAME AS UI
    })
  );

  if (isPracticeMode) {
    dispatch(resetPracticeStreak());
  }

  setSubmitModalOpen(false);
  setShowTimeUpModal(false);

  if (isPracticeMode) {
    history.push("/practice-summary");
  } else {
    history.push("/analytics", {
      from_submit: true,
      paper_type: testDetails?.paperType ?? plannerDetails?.id,
      paper_id: paperId ?? testDetails?.paperId,
      set_id: selectedSetId ?? testDetails?.setId,
      planner_test_id:
        testDetails?.planner_test_id ?? plannerDetails?.planner_id,
    });
  }
};

const handleTimeUpAutoSubmit = () => {
  if (isPracticeMode || hasAutoSubmittedRef.current) return;

  hasAutoSubmittedRef.current = true;
  setShowTimeUpModal(true);

  autoSubmitTimeoutRef.current = setTimeout(() => {
    handleSubmitExam();
  }, 2200);
};

useEffect(() => {
  return () => {
    if (autoSubmitTimeoutRef.current) {
      clearTimeout(autoSubmitTimeoutRef.current);
    }
  };
}, []);
const handleExitTest = () => {
  const currentQuestion = questionsData[currentQuestionIndex];
  if (currentQuestion) {
    const answerType = Number(currentQuestion.answer_type_id);
    dispatch(
      saveAnswerRequest({
        qid: currentQuestion.qid,
        paper_id: currentQuestion.paper_id,
        paper_type: testDetails?.paperType,
        test_id: testDetails?.testId,
        set_id: selectedSetId,
        time: currentQuestion?.time_taken ?? 0,
        option_id:
          answerType === 1 || answerType === 2
            ? currentQuestion?.selectedOption ?? ""
            : "",
        option_int:
          answerType === 3
            ? currentQuestion?.integerAnswer ??
              currentQuestion?.integer_Answer ??
              ""
            : "",
        question_status: getBackendQuestionStatus(currentQuestion),
        skipAdvance: true,
      })
    );
  }

  const source = testDetails?.source;

  if (source === "topicwise") {
    history.push("/practice/topic-wise/pyqset");
  } 
  else if (source === "yearwise") {
    history.push("/practice/paper-listing?type=Year Wise");
  } 
  else {
    history.push("/practice/paper-listing");
  }
};

const activeQuestion =
  questionsData?.[currentQuestionIndex] || null;


//Blank Screen Problem --> Q no appears on screen but ques not loading: fixed by below code

useEffect(() => {
  if (
    testDetails?.isResume === true &&   
    activeQuestion?.qid                
  ) {
    dispatch(
      fetchExamQuestionRequest({
        qid: activeQuestion.qid,
        paperId: activeQuestion.paper_id,
        testId: testDetails?.testId,
        setId: selectedSetId,
      })
    );
  }
}, [testDetails?.isResume]); 

//Sync all answered questions ONCE (no multiple API calls)
const hasSyncedAllRef = useRef(false);

useEffect(() => {
  if (
    testDetails?.isResume === true &&
    questionsData?.length &&
    !hasSyncedAllRef.current
  ) {
    hasSyncedAllRef.current = true;

    const answeredQuestions = questionsData.filter((q) => {
      return (
        (Array.isArray(q.selectedOption) && q.selectedOption.length > 0) ||
        (q.selectedOption && q.selectedOption !== "") ||
        (q.integerAnswer && String(q.integerAnswer).trim() !== "")
      );
    });

    answeredQuestions.forEach((q, index) => {
      setTimeout(() => {
        const answerType = Number(q.answer_type_id);

        dispatch(
          saveAnswerRequest({
            qid: q.qid,
            paper_id: q.paper_id,
            paper_type: testDetails?.paperType,
            test_id: testDetails?.testId,
            set_id: selectedSetId,
            time: q?.time_taken ?? 0,

            option_id:
              answerType === 1 || answerType === 2
                ? q.selectedOption ?? ""
                : "",

            option_int:
              answerType === 3
                ? q.integerAnswer ?? q.integer_Answer ?? ""
                : "",

            question_status: getBackendQuestionStatus(q),
            skipAdvance: true,
          })
        );
      }, index * 30); // spacing prevents API burst
    });
  }
}, [testDetails?.isResume, questionsData]);




//QUES NOT SAVING AFTER RESUME- FIXED BELOW

//Suppose you ans 3 ques then exit test in practice mode...after that you again resume the test now it was starting from scratch
//means if you submit it will ignore saved answers of prev attempt
//Below useeffect code fixed this issue

// useEffect(() => {
//   if (
//     testDetails?.isResume === true &&
//     questionsData?.length
//   ) {
//     questionsData.forEach((q) => {
//       const answerType = Number(q.answer_type_id);

//       const hasAnswer =
//         (Array.isArray(q.selectedOption) && q.selectedOption.length > 0) ||
//         (q.selectedOption && q.selectedOption !== "") ||
//         (q.integerAnswer && String(q.integerAnswer).trim() !== "");

//       if (hasAnswer) {
//         dispatch(
//           saveAnswerRequest({
//             qid: q.qid,
//             paper_id: q.paper_id,
//             paper_type: testDetails?.paperType,
//             test_id: testDetails?.testId,
//             set_id: selectedSetId,
//             time: q?.time_taken ?? 0,

//             option_id:
//               answerType === 1 || answerType === 2
//                 ? q.selectedOption ?? ""
//                 : "",

//             option_int:
//               answerType === 3
//                 ? q.integerAnswer ?? q.integer_Answer ?? ""
//                 : "",

//             question_status: getBackendQuestionStatus(q),
//             skipAdvance: true, 
//           })
//         );
//       }
//     });
//   }
// }, [testDetails?.isResume, questionsData]);

  if (loading) {
    return (
      <div className="loading_center_container">
        <ClipLoader size={40} color="#C61C26" />
      </div>
    );
  }

  return (
    <div className="exam-wrapper">
      <Header
       onSubmit={() => setSubmitModalOpen(true)} 
        onExitClick={() => setShowExitModal(true)}
        onTimeUp={handleTimeUpAutoSubmit}
       />

      {/* <div className="exam-body"> */}
        {/* <div className="exam-content"> */}
   <div className={"exam-body with-overview"}>
          <div className="exam_content_container">
            
          {isPracticeMode && testDetails?.gamificationOn === true && (
            <div style={{ margin: "0 0 24px 0", padding: "0 16px" }}>
              <PracticeModeProgressBar
                totalQuestions={questionsData.length}
                streak={practiceStreak}
                currentQuestionIndex={currentQuestionIndex}
                allQuestionsAttempted={allQuestionsAttempted}
              />
            </div>
          )}

            <SectionTabs onSelectQuestion={handleSelectQuestion} />

            {/* <QuestionCard questionId={activeQuestionId} /> */}
            {/* {activeQuestionId && (
  <QuestionCard questionId={activeQuestionId} />
)} */}

            {activeQuestion && (
              <QuestionCard
                key={activeQuestion.qid + "-" + currentQuestionIndex}
                questionId={activeQuestion.qid}
              />
            )}

            <Footer
              onSaveNext={handleSaveAndNext}
              onMarkReview={onMarkReview}
            />
          </div>
        </div>
      {/* </div> */}

      {/* ======================= SUBMIT MODAL ======================= */}
      <SubmitModal
        isOpen={isSubmitModalOpen}
        onClose={() => setSubmitModalOpen(false)}
        onSubmit={handleSubmitExam}
        title="Submit Exam?"
        subtitle="Are you sure you want to submit your answers?"
        imageSrc={images.submit_icon}
        totalQuestions={questionsData?.length || 0}
        notAttempted={stats.notVisited + stats.notAnswered}
        attempted={stats.answered}
        markedForReview={stats.marked + stats.answeredMarked}
        cancelButtonProps={{
          title: "Cancel",
          variant: "outlined",
          color: "error",
          onClick: () => setSubmitModalOpen(false),
        }}
        submitButtonProps={{
          title: loading ? "Submitting..." : "Submit",
          variant: "contained",
          color: "error",
          onClick: handleSubmitExam,
        }}
      />
      {/* This is for exit modal */}
      <SubmitModal
  isOpen={showExitModal}
  onClose={() => setShowExitModal(false)}
  title="Exit Test"
  subtitle="Are you sure you want to exit? Your answers are saved and you can resume anytime."
  imageSrc={images.exit_modal_icon}
  totalQuestions={questionsData?.length || 0}
  notAttempted={stats.notVisited + stats.notAnswered}
  attempted={stats.answered}
  markedForReview={stats.marked + stats.answeredMarked}
  cancelButtonProps={{
    title: "Go Back To Test",
    variant: "outlined",
    color: "error",
    onClick: () => setShowExitModal(false),
  }}
  submitButtonProps={{
    title: "Exit Test",
    variant: "contained",
    color: "error",
    onClick: handleExitTest,
  }}
/>

      <Modal
        isOpen={showTimeUpModal}
        onClose={() => {}}
        height="14rem"
        width="32rem"
      >
        <div className="timeup-modal-content">
          <div className="timeup-modal-title">Time is up</div>
          <div className="timeup-modal-subtitle">
            The test will be auto submitted.
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TestScreen;
